import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="3" viewBox="-1 -1 11 5">
    <path d="M0 2.5h9" stroke="#424b57" strokeDasharray="1,3" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/dotted-border.es6.js